import {Component, OnInit} from '@angular/core';
import {APIService} from '../../services/APIService';
import {MatSnackBar} from '@angular/material/snack-bar';

interface OwnerChangeRequestRow {
  id: number;
  booth_id: number;
  requested_by_uuid: string;
  new_owner_uuid: string;
  new_owner_username: string;
  new_owner_discord_id: string;
  email: string;
  status: 'PENDING' | 'ACCEPTED' | 'DENIED';
  reason?: string;
  decided_by_uuid?: string;
  created_at: string;
  decided_at?: string;
}

@Component({
  selector: 'app-booth-owner-change-requests',
  templateUrl: './booth-owner-change.component.html',
  styleUrls: ['./booth-owner-change.component.css']
})
export class BoothOwnerChangeRequestsComponent implements OnInit {
  loading = false;
  requests: OwnerChangeRequestRow[] = [];
  statusFilter: 'PENDING' | 'ACCEPTED' | 'DENIED' | 'ALL' = 'PENDING';
  denyReason: {[id: number]: string} = {};

  displayedColumns = ['id','booth','requestedBy','newOwner','discord','email','status','reason','actions'];

  constructor(private api: APIService, private snack: MatSnackBar) {}

  ngOnInit(): void {
    this.refresh();
  }

  async refresh() {
    this.loading = true;
    try {
      this.requests = await this.api.listOwnerChangeRequests(this.statusFilter) as any;
    } catch (e: any) {
      this.snack.open('Failed to load requests: ' + e, 'Close', { duration: 4000 });
    } finally {
      this.loading = false;
    }
  }

  async accept(row: OwnerChangeRequestRow) {
    try {
      await this.api.acceptOwnerChangeRequest(row.id);
      this.snack.open('Accepted request #' + row.id, 'Close', { duration: 3000 });
      this.refresh();
    } catch (e: any) {
      this.snack.open('Accept failed: ' + e, 'Close', { duration: 4000 });
    }
  }

  async deny(row: OwnerChangeRequestRow) {
    const reason = (this.denyReason[row.id] || '').trim();
    if (!reason) {
      this.snack.open('Please provide a reason to deny', 'Close', { duration: 3000 });
      return;
    }
    try {
      await this.api.denyOwnerChangeRequest(row.id, reason);
      this.snack.open('Denied request #' + row.id, 'Close', { duration: 3000 });
      this.denyReason[row.id] = '';
      this.refresh();
    } catch (e: any) {
      this.snack.open('Deny failed: ' + e, 'Close', { duration: 4000 });
    }
  }
}
